import { render } from "./FinishScreen.vue?vue&type=template&id=17b1990a"
import script from "./FinishScreen.vue?vue&type=script&lang=js"
export * from "./FinishScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Sites/progressive_reaction_game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__